export class FormStateEnum {
    static default = 0;
    static error = 1;
    static success = 2;
}

export default class CustomRoute {
    constructor({ component, alias, description, props }) {
        this.alias = alias;
        this.description = description;
        this.component = component;
        this.props = props;
    }
}


export class FormCustomRoute extends CustomRoute {
    constructor({ component, alias, description, props, state, other }) {
        super({ component, alias, description, props, state });
        this.state = state || FormStateEnum.default;
        this.other = other;
    }

    setState(newState) {
        this.state = newState;
    }
}
